__turbopack_context__.v({
  "variantContainer": "x5ncDa_variantContainer",
});
